jQuery(document).ready(function ($) {
  $(".modalVideo").click(function (event) {
    event.preventDefault();
  });
  $(".modalVideo.modalVideo--youtube").modalVideo({
    channel: "youtube",
    youtube: {
      autoplay: 1,
      rel: 0,
    },
  });

  $(".modalVideo.modalVideo--vimeo").modalVideo({
    channel: "vimeo",
    vimeo: {
      autoplay: true,
    },
  });

  $(".csLottieAnimation").each(function (index, val) {
    var inview = new Waypoint.Inview({
      element: $(this),
      enter: function (direction) {
        var $target = $(this.element[0]);
        $target[0].play();
      },
      entered: function (direction) {},
      exit: function (direction) {},
      exited: function (direction) {
        var $target = $(this.element[0]);
        $target[0].currentTime = 0;
      },
    });
  });
});
